<template>
<div id="contentbg">
    <div class="tonglan">
        <div class="yjdjs">
            <!--左侧内容-->
            <div class="yjdleft">
                <a name="a" id="a"></a>
                <h3>区域合作伙伴计划</h3>
                <ul>
                    <li>
                        <p>
                            <a name="b" id="b"></a>
                            药聚多区域合作伙伴计划是北京汉宁恒丰医药科技股份有限公司针对医药分销领域的特殊性设置的医药电商合作项目。该项目主要在全国范围内招募区域合作伙伴，向其所属区域内的药店、诊所、民营医院等第二三终端推广药聚多平台，解决客户系统安装过程中出现的问题。同时通过整合平台品种加自有品种，向该所属区域内的终端进行药品的分销工作，提供全程交易过程中出现的问题及服务。
                            <!-- <span class="jiameng"><router-link to="/Enter">立即加盟</router-link></span> -->
                        </p>
                        <p>
                            <strong class="font16">我们的优势</strong>
                        </p>
                        <div class="yousx">
                            <dl>
                                <dt>
                                    <img src="../assets/wwsp.png" width="213" height="200" />
                                    <strong class="font16">多</strong><br />
                                    <span>汇集8万在线品规<br />海量产品任意采购</span>
                                </dt>
                                <dt class="rjx">
                                    <img src="../assets/xtjd.png" width="213" height="200" />
                                    <strong class="font16">云</strong><br />
                                    <span>
                                        所有产品上传至云库存<br />轻松化解库存压力及风险
                                    </span>
                                </dt>
                                <dt class="rjx">
                                    <img src="../assets/sjfx.png" width="213" height="200" />
                                    <strong class="font16">精</strong><br />
                                    <span>
                                        平台强大数据库，智能分析<br />药品营销更专业、更精准
                                    </span>
                                </dt>
                                <a name="c" id="c"></a>
                                <dt class="rjx">
                                    <img src="../assets/zykf.png" width="213" height="200" />
                                    <strong class="font16">好</strong><br />
                                    <span>
                                        属地化服务团队<br />专业解决客户难题
                                    </span>
                                </dt>
                            </dl>
                        </div>
                        <a name="d" id="d"></a>

                        <div class="tonglan" id="register">
                            <div class="yjdjs">
                                <!--立即咨询-->
                                <div class="zixun1" v-loading="submitLoading">
                                    <h3>立即咨询</h3>
                                    <p class="a3 pp">
                                        感谢您关注 “药聚多”。无论您是买家、卖家、区域服务经理还是想使用药聚多云服务，我们都能帮助评估您的需求并确定适合的解决方案。若要咨询客服代表，请填写以下信息，我们会根据您的情况第一时间联系您
                                    </p>
                                    <div style="margin:0 auto;width:500px;" v-show="!showResult">
                                        <el-form ref="regForm" :model="regModel" :rules="rules"  label-width="80px">
                                            <el-form-item label="注册类型">
                                                <el-radio v-for="regType in regTypes" v-model="regModel.type" :label="regType.value" border size="medium" :key="regType.value">{{regType.title}}</el-radio>
                                            </el-form-item>
                                            <el-form-item prop="mobile" label="手机号：">
                                                <el-input v-model="regModel.mobile"></el-input>
                                            </el-form-item>
                                            <el-form-item prop="code" label="验证码：">
                                                <el-input v-model="regModel.code">
                                                    <el-button :disabled="!codeButtonDisable" slot="append" icon="el-icon-s-promotion" type="danger" plain @click="sendValidCode">{{codeButtonText}}</el-button>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button style="width:100%" type="danger" @click="submitRegInfo">提交</el-button>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                    <el-result v-show="showResult" :icon="resultSuccess ? 'success' : 'error'" :title="resultSuccess ? '提交成功' : '提交失败'" :subTitle="resultMsg">
                                        <template slot="extra">
                                            <el-button type="primary" size="medium" @click="back">返回</el-button>
                                        </template>
                                    </el-result>
                                </div>
                            </div>
                        </div>

                        <p style="padding-top:30px;"><strong class="font16">合作伙伴标准</strong></p>
                        <p>
                            1、有药店、诊所等终端市场拓展能力的医药公司或自然人；<br />

                            2、对医药电商感兴趣，并认同药聚多经营理念。
                        </p>
                        <p><strong class="font16">项目足迹</strong></p>
                            <div class="xct">
                                <div id="wrapper">
                                    <div id="jsCarousel" class="jscarousal-contents">
                                        <div>
                                            <img src="../assets/2018成都调研会.jpg" /><br />
                                            <span class="thumbnail-text">2018成都调研会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2017国药会.jpg" /><br />
                                            <span class="thumbnail-text">2017国药会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2018华药会现场.jpg" /><br />
                                            <span class="thumbnail-text">2018华药会现场</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2016年上海国药会.jpg" /><br />
                                            <span class="thumbnail-text">上海国药会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/第9届区域服务经理推介会.jpg" /><br />
                                            <span class="thumbnail-text">服务经理推介会</span>
                                        </div>
                                        <br/>
                                        <div>
                                            <img src="../assets/2016华药会.jpg" /><br />
                                            <span class="thumbnail-text">华药会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2015成都会.jpg" /><br />
                                            <span class="thumbnail-text">2015成都会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2018山东会.jpg" /><br />
                                            <span class="thumbnail-text">2018山东会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2018广东推介会.jpg" /><br />
                                            <span class="thumbnail-text">2018广东推介会</span>
                                        </div>
                                        <div>
                                            <img src="../assets/2018太和药聚多推介会.jpg" /><br />
                                            <span class="thumbnail-text">2018太和药聚多推介会</span>
                                        </div>
                                    </div>
                                </div>
                                <!--wrapper end-->
                            </div>
                        <p><strong class="font16">加盟咨询</strong></p>
                        <p>
                            宋经理：13866202981 &nbsp; 浙江、江西、山西、上海、吉林、广东、广西、青海、贵州、四川、黑龙江<br>

                            张经理：15755835088 &nbsp; 福建、新疆、北京、宁夏、重庆、云南、河南、安徽、辽宁、内蒙古<br>

                            齐经理：15655873330 &nbsp; 山东、海南、西藏、河北、湖北、湖南、江苏、甘肃、天津、陕西<br><br />
                        </p>
                    </li>
                </ul>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</div>
</template>
<style scoped lang="less">
    @import "../style/cyz";
</style>
<script>
import { sendValidCode, submitRegInfo } from '../api/register'
export default {
  name: 'Cyz',
  data () {
    return {
      regTypes: [
        { title: '买家', value: '0' },
        { title: '卖家', value: '1' },
        { title: '区域合作伙伴计划', value: '2' }],
      regModel: { mobile: '', code: '', type: '0' },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      showResult: false,
      resultSuccess: true,
      resultMsg: '',
      submitLoading: false,
      timer: {},
      times: 60,
      codeButtonDisable: true,
      codeButtonText: '获取验证码'
    }
  },
  mounted () {
    if (this.$route.query.target) {
      this.scrollToElement(this.$route.query.target)
    }
  },
  methods: {
    checkPhone () {
      if (!this.regModel.mobile) {
        this.$message.error('请输入手机号')
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(this.regModel.mobile)) {
          return true
        } else {
          this.$message.error('手机号码格式不正确')
        }
      }
      return false
    },
    sendValidCode () {
      if (!this.checkPhone()) {
        return
      }
      sendValidCode({ mobile: this.regModel.mobile }).then(response => {
        this.codeButtonDisable = false
        this.timer = setInterval(() => {
          this.times--
          this.codeButtonText = `${this.times}秒后可再次获取`
          if (this.times === 0) {
            this.times = 60
            this.codeButtonDisable = true
            this.codeButtonText = '获取验证码'
            clearInterval(this.timer)
          }
        }, 1000)
      })
    },
    submitRegInfo () {
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          submitRegInfo(this.regModel).then(response => {
            this.showResult = true
            this.submitLoading = false
            this.resultSuccess = false
            if (response.data === 'SUCCESS') {
              this.resultSuccess = true
              this.resultMsg = '信息提交成功，请耐心等待客服与您联系。'
            } else if (response.data === 'CODEERROR') {
              this.resultMsg = '验证码错误，请检查输入是否正确，或者重新获取。'
            } else if (response.data === 'REPEAT') {
              this.resultMsg = '您已提交过注册信息，请等待客服人员与您联系。'
            } else {
              this.resultMsg = '注册失败，请稍候再试。'
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    scrollToElement (elementId) {
      const el = document.getElementById(elementId)
      if (el) {
        // 平滑滚动到元素位置
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    back () {
      if (this.resultSuccess) {
        this.$refs.regForm.resetFields()
      }
      this.showResult = false
    }
  }
}
</script>
